const TOKEN_REGEX = /^\{\$([^}]+)\}$/;
export const isToken = (x: string) => !!x.match(TOKEN_REGEX);
export const getTokenName = (x: string): string => x.match(TOKEN_REGEX)![1];
export const makeToken = (x: string): string => `{$${x}}`;
